import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  adjustSpace: {
    alignSelf: "flex-start",
  },
  rightContainer: {
    alignSelf: "end",
  },
  TradeVolume: {
    width: "calc(100% - 120px)",
  },
  marginBottom: {
    marginBottom: theme.spacing(6),
  },
  SelectCurrencyLayout: {
    height: theme.spacing(124),
  },
  RecentTransactionsLayout: {
    height: theme.spacing(160),
  },
  chart: {
    height: theme.spacing(140),
  },
  order: {
    minHeight: theme.spacing(142),
    height: "100%",
  },
  table: {
    minHeight: theme.spacing(110),
    height: "100%",
  },
  OrderBook: {
    minHeight: theme.spacing(405),
  },
}));
